export default "__VITE_ASSET__VYkuZque__"